module.exports = __webpack_public_path__ + "static/intercomxls-6c3d3aaf4452cfd21c2b83a99d48cd62.png";